// extracted by mini-css-extract-plugin
module.exports = {"scrollbar":"style_scrollbar__1l6qW"};